// extracted by mini-css-extract-plugin
export default {"loadingbtn":"Button_loadingbtn__MBFx1","rotate":"Button_rotate__YVVBB"};